'use strict';

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LinkedinShare = function (_React$Component) {
  (0, _inherits3["default"])(LinkedinShare, _React$Component);

  function LinkedinShare(props) {
    (0, _classCallCheck3["default"])(this, LinkedinShare);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (LinkedinShare.__proto__ || Object.getPrototypeOf(LinkedinShare)).call(this, props));

    _this.state = {
      link: props.link
    };
    return _this;
  }

  (0, _createClass3["default"])(LinkedinShare, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.link) {
        this.setState({
          link: document.location.href
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.link !== prevProps.link) {
        this.setState({
          link: this.props.link
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children('https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(this.state.link) + '&title=' + this.props.title + '&summary=' + this.props.summary + '&source=');
    }
  }]);
  return LinkedinShare;
}(_react2["default"].Component);

LinkedinShare.defaultProps = {
  title: '',
  summary: ''
};
exports["default"] = LinkedinShare;